import { AppointmentType } from "../types";

export const appointmentKeys = {
    all: ["appointments"] as const,
    appointments: (type?: AppointmentType) => [...appointmentKeys.all, type] as const,
    appointment: (id: string) => [...appointmentKeys.all, id] as const,
  } as const;

